const courriers = [
    {
        label: 'APC',
        value: 'APC',
    },
    {
        label: 'Asendia USA',
        value: 'AsendiaUsa',
    },
    {
        label: 'Australia Post',
        value: 'AustraliaPost',
    },
    {
        label: 'Canada Post',
        value: 'CanadaPost',
    },
    {
        label: 'Canpar',
        value: 'Canpar',
    },
    {
        label: 'Chronopost',
        value: 'Chronopost',
    },
    {
        label: 'Deutsche Post',
        value: 'DeutschePost',
    },
    {
        label: 'DHL eCommerce Asia',
        value: 'DHLEcommerceAsia',
    },
    {
        label: 'DHL Express',
        value: 'DHLExpress',
    },
    {
        label: 'DPD',
        value: 'DPD',
    },
    {
        label: 'DPD UK',
        value: 'DPDUK',
    },
    {
        label: 'Evri',
        value: 'Evri',
    },
    {
        label: 'FedEx',
        value: 'FedEx',
    },
    {
        label: 'La Poste',
        value: 'LaPoste',
    },
    {
        label: 'LaserShip',
        value: 'LaserShipV2',
    },
    {
        label: 'OnTrac',
        value: 'OnTrac',
    },
    {
        label: 'PostNL',
        value: 'PostNL',
    },
    {
        label: 'Purolator',
        value: 'Purolator',
    },
    {
        label: 'Royal Mail',
        value: 'RoyalMail',
    },
    {
        label: 'Sendle',
        value: 'Sendle',
    },
    {
        label: 'UPS',
        value: 'UPS',
    },
    {
        label: 'USPS',
        value: 'USPS',
    },
]

// Mantine
import { Select } from '@mantine/core'

export default function CarrierSelect({ value, onChange }) {
    return (
        <Select
            data={courriers}
            value={value}
            onChange={onChange}
            placeholder="Choisir un transporteur"
            label="Transporteur"
            searchable
        />
    )
}
